import Masters from "../Masters";
import CustomDialog from "../../../../Components/CustomDialog";
import { Box, DialogTitle } from "@mui/material";
import { rowSB } from "../../../../GlobalStyles";
import { subHeading } from "../../../../Components/CustomTexts";
import CustomIconButton from "../../../../Components/CustomIconButton";
import SvgPreview from "../../../../Components/SvgPreview";
import { cross } from "../../../../assets/svgs";

function TemplateWrapper({
  setOpenTemplate,
  level,
  parent,
  parent_name,onSubmit
}: {
  setOpenTemplate: (open: boolean) => void;
  parent: any;
  parent_name?: string;
  level:
    | "exam"
    | "goal"
    | "section"
    | "unit"
    | "topic"
    | "subtopic"
    | "cluster";
    onSubmit:any
}) {
  return (
    <CustomDialog
      title={`Cloning an ${level} ${parent_name ? `under ${parent_name}` : ""}`}
      customHeader={
        <DialogTitle
          sx={{
            m: 0,
            p: "20px 15px 5px",
            ...rowSB,
            height: "48.98px",
            boxSizing: "border-box",
          }}
          id="customized-dialog-title"
        >
          {subHeading({
            text: `Pick a ${level} ${
              parent_name ? `and copy under ${parent_name}` : ""
            }`,
            size: "1.1rem",
            weight: "600",
          })}
          <CustomIconButton
            onClick={() => {
              setOpenTemplate(false);
            }}
            noHover={true}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
            content={<SvgPreview svg={cross} />}
          />
        </DialogTitle>
      }
      open={true}
      onClose={() => {
        setOpenTemplate(false);
      }}
      contentsx={{
        minHeight: "431px !important",
      }}
      sx={{
        "& .MuiDialog-paperWidthSm": {
          minWidth: "100% !important",
          minHeight: "100dvh !important",
          borderRadius: "0 !important",
          margin: "0",
        },
        "& .MuiDialogContent-root": {
          padding: "0 !important",
          minWidth: "100% !important",
          minHeight: "100% !important",
          height: "100%",
          width: "100%",
          boxSizing: "border-box",
          display: "flex",
          overflow: "hidden",
        },
      }}
      actions={[]}
      content={
        <Box
          sx={{
            width: "100%",
            height: "calc(100dvh - 48.98px)",
            minHeight: "calc(100dvh - 48.98px)",
            flex: 8,
            padding: "0 !important",
            overflow: "hidden",
          }}
        >
          <Masters
            level={level}
            parent={parent}
            parent_name={parent_name}
            onSubmit={()=>{
              setOpenTemplate(false);
              onSubmit();
            }}
            onClose={() => {
              setOpenTemplate(false);
            }}
          />
        </Box>
      }
    />
  );
}

export default TemplateWrapper;
